import { useSyncExternalStore } from "react"

/**
 * Playhead time, published from GSAP's `onUpdate` roughly 50x per second.
 *
 * Deliberately NOT React state. It used to be `useState` inside `useSliderTime`, which is
 * called from `TimelineNavbar` — so every frame of playback re-rendered the whole timeline
 * subtree: 500 timestamps, 300 rows and 6 000 time steps, none of which depend on the time
 * at all. `memo()` could not help, because the state lived in the parent itself.
 *
 * Only the few components that really display the playhead subscribe here.
 */

let currentTime = 0
const listeners = new Set<() => void>()

export const publishCurrentTime = (time: number) => {
    if (time === currentTime) return
    currentTime = time
    listeners.forEach((listener) => listener())
}

/** Imperative read for event handlers that must not re-render on every frame. */
export const getCurrentTime = (): number => currentTime

const subscribe = (listener: () => void) => {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}

const getSnapshot = () => currentTime

export const useCurrentTime = (): number =>
    useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
